// ¿Hay que ignorar el autoscroll hacia este mensaje?
//
// ChatMessageComponent pide `scroll-to-msg` cada vez que termina de escribirse
// un mensaje. El problema son los pasos que avanzan solos: un paso
// "informative", y un paso "custom-component" sin `getAnswers` y con
// `dontShowNextButton` (la vista de invitar, las misiones) emiten `continue`
// apenas se muestran, así que el chatbot agrega el menú siguiente sin que el
// usuario haya pedido nada. Ese menú pide su propio scroll, gana por ser el
// último, y arrastra al usuario más allá de lo que acababa de abrir: apretabas
// "Invitar colegas" y terminabas mirando el menú, con la tarjeta de invitación
// arriba, fuera de pantalla.
//
// La regla: si el mensaje anterior avanzó solo, este no manda el scroll.
export const skipAutoScroll = (messages, name) => {
  const idx = messages.map((msg) => msg.name).lastIndexOf(name);
  if (idx <= 0) return false;
  const prev = messages[idx - 1];
  if (!prev) return false;
  if (prev.type === "informative") return true;
  return (
    prev.type === "custom-component" &&
    !!prev.dontShowNextButton &&
    !prev.getAnswers
  );
};
